export default __webpack_public_path__ + "static/media/notification.ba83cbd2.svg";